import { NgModule } from '@angular/core';
import { HavijComponent } from './havij.component';



@NgModule({
  declarations: [HavijComponent],
  imports: [
  ],
  exports: [HavijComponent]
})
export class HavijModule { }
